import { useAuth } from "@/hooks/useAuth";
import { Navigate, Outlet } from "react-router-dom";
import { Spinner } from "@/components/ui/spinner";

export default function ProtectedRoute() {
  const { token, user } = useAuth();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!user) {
    return <Spinner />;
  }

  return <Outlet />;
}
